import { ICustomAnalysisColor } from './types';

export const mainBlueCustomColor: ICustomAnalysisColor = {
  label: 'Blue',
  // should always use the hex color in settings.
  hex: '#006bd3',
};

export const measureColors: ICustomAnalysisColor[] = [
  mainBlueCustomColor,
  {
    label: 'Yellow',
    hex: '#ffb931',
  },
  {
    label: 'Forest Green',
    hex: '#017018',
  },
  {
    label: 'Deep Purple',
    hex: '#5452cc',
  },
  {
    label: 'Teal Blue',
    hex: '#2ea7bd',
  },
  {
    label: 'Plum',
    hex: '#9f4bc9',
  },
  {
    label: 'Sky Blue',
    hex: '#6cafff',
  },
];

export const sliceColors: ICustomAnalysisColor[] = [
  {
    label: 'Orange',
    hex: '#f07813',
  },
  {
    label: 'Violet',
    hex: '#610fe6',
  },
  {
    label: 'Green',
    hex: '#269e41',
  },
  {
    label: 'Magenta',
    hex: '#ce3bdc',
  },
  {
    label: 'Turquoise Blue',
    hex: '#41acbc',
  },
  {
    label: 'Mint Green',
    hex: '#1ebf8f',
  },
  {
    label: 'Black',
    hex: '#31373d',
  },
  {
    label: 'Rose',
    hex: '#e1609b',
  },
  {
    label: 'Royal Blue',
    hex: '#0070f5',
  },
  {
    label: 'Brown',
    hex: '#ad3a00',
  },
];

export const customColors = [
  '#FEB931',
  '#F07812',
  '#CE3BDC',
  '#9747FF',
  '#610FE6',
  '#60A6FF',
  '#41ACBC',
  '#259E40',
];

export const sankeyChartColors = [
  mainBlueCustomColor.hex,
  '#f07813', // orange
  '#610fe6', // purple
  '#269e41', // green
  '#ce3bdc', // pink
  '#41acbc', // light-blue
  '#1ebf8f', // light-green
  '#31373d', // black
  '#e1609b', // pink
  '#0070f5', // blue
  '#ad3a00', // brown
  '#610fe6', // purple
  '#269e41', // green
  '#ce3bdc', // pink
  '#41acbc', // light-blue
  '#1ebf8f', // light-green
  '#31373d', // black
];
